import {NgModule} from "@angular/core";
import {VerticalListScrollableComponent} from "./vertical.list.scrollable.component";
import {GridModule} from "@progress/kendo-angular-grid";
import {VerticalListScrollableItemDirective} from "./vertical.list.scrollable.item.directive";
import {CommonModule} from "@angular/common";

export {VerticalListScrollableComponent} from "./vertical.list.scrollable.component";
export {VerticalListScrollableItemDirective} from "./vertical.list.scrollable.item.directive";

@NgModule({
	imports: [GridModule, CommonModule],
	declarations:[VerticalListScrollableComponent,
		VerticalListScrollableItemDirective],
	exports:[VerticalListScrollableComponent,
		VerticalListScrollableItemDirective]
})
export class VerticalListSCrollbleModle{

}
